module.exports = __webpack_public_path__ + "media/images/regional-image14-ee82f3b0734f2487f28a387c57dd7093.jpg";